import { createElement, memo, useContext } from '@max/max';
import View from '@hfe/max-view';
import './index.scss';
import BuyTickets from './components/buyTickets';
import StrategyGuide from './components/strategyGuide';
const MyComponent = (props) => {
    // 从全局变量global取Context
    const ctx = useContext(global._EngineGlobalContext);
    const { intervalDays, buyTicketConfig, strategyConfig, _LXReport, _raptorReport } = props;
    // 调用引擎注入的自定义API
    const moduleId = ctx._moduleId;
    return <View className="ticket-entrance-container">
      <View className="ticket-entrance-left-container">
        <BuyTickets _LXReport={_LXReport} config={buyTicketConfig} intervalDays={intervalDays}/>
      </View>
      <View className="ticket-entrance-right-container">
        <StrategyGuide config={strategyConfig} _LXReport={_LXReport}/>
      </View>
    </View>;
};
export default memo(MyComponent);
